import styled from "styled-components";
import { useLocation } from "react-router-dom"
// import { useState, useEffect } from "react";


export default function WelcomeText(props) {

    var date = new Date()
    let data = useLocation();
    

    return(
        <StyledWelcome>
            <h2 className="un">
                Welcome  <span className="star" style={{color: `${props.star}` }} >{data.state}</span>, this is your {date.toLocaleTimeString()} Star Color:
            </h2>
        </StyledWelcome>
    )
}

const StyledWelcome = styled.div`
width: 75%;
height: auto;
`